//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class CaseClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7232";

    }

    getCaseFilters( cancelToken?: CancelToken | undefined): Promise<CaseFilters> {
        let url_ = this.baseUrl + "/api/Case/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseFilters(_response);
        });
    }

    protected processGetCaseFilters(response: AxiosResponse): Promise<CaseFilters> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CaseFilters.fromJS(resultData200);
            return Promise.resolve<CaseFilters>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseFilters>(null as any);
    }

    getCaseUsers(caseId: string, cancelToken?: CancelToken | undefined): Promise<CaseUsersDto> {
        let url_ = this.baseUrl + "/api/Case/case-users/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseUsers(_response);
        });
    }

    protected processGetCaseUsers(response: AxiosResponse): Promise<CaseUsersDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CaseUsersDto.fromJS(resultData200);
            return Promise.resolve<CaseUsersDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseUsersDto>(null as any);
    }

    setCaseUsers(command: SetCaseUsersCommand, cancelToken?: CancelToken | undefined): Promise<CaseUserDto[]> {
        let url_ = this.baseUrl + "/api/Case/case-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetCaseUsers(_response);
        });
    }

    protected processSetCaseUsers(response: AxiosResponse): Promise<CaseUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CaseUserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseUserDto[]>(null as any);
    }

    getCases(query: GetCasesQuery, cancelToken?: CancelToken | undefined): Promise<CaseDto[]> {
        let url_ = this.baseUrl + "/api/Case/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCases(_response);
        });
    }

    protected processGetCases(response: AxiosResponse): Promise<CaseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CaseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CaseDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseDto[]>(null as any);
    }

    createCase(caseManagerId: number | undefined, personalData_Id: number | null | undefined, personalData_CaseId: string | undefined, personalData_PipelineCaseNumber: string | null | undefined, personalData_ProgramId: string | null | undefined, personalData_FirstName: string | null | undefined, personalData_LastName: string | null | undefined, personalData_DateOfBirth: string | null | undefined, personalData_Gender: GenderType | null | undefined, personalData_Street: string | null | undefined, personalData_Zip: string | null | undefined, personalData_City: string | null | undefined, personalData_Phone: string | null | undefined, personalData_MobilePhone: string | null | undefined, personalData_Email: string | null | undefined, personalData_InsuranceId: string | null | undefined, personalData_AeromedicalExaminer: string | null | undefined, personalData_HealthInsurance: string | null | undefined, personalData_AirlineId: string | null | undefined, personalData_Fleet: string | null | undefined, personalData_FunctionId: string | null | undefined, historyData_HistoryItemText: string | null | undefined, historyData_Files: FileDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<ServiceResultOfGuid> {
        let url_ = this.baseUrl + "/api/Case/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (caseManagerId === null || caseManagerId === undefined)
            throw new Error("The parameter 'caseManagerId' cannot be null.");
        else
            content_.append("CaseManagerId", caseManagerId.toString());
        if (personalData_Id !== null && personalData_Id !== undefined)
            content_.append("PersonalData.Id", personalData_Id.toString());
        if (personalData_CaseId === null || personalData_CaseId === undefined)
            throw new Error("The parameter 'personalData_CaseId' cannot be null.");
        else
            content_.append("PersonalData.CaseId", personalData_CaseId.toString());
        if (personalData_PipelineCaseNumber !== null && personalData_PipelineCaseNumber !== undefined)
            content_.append("PersonalData.PipelineCaseNumber", personalData_PipelineCaseNumber.toString());
        if (personalData_ProgramId !== null && personalData_ProgramId !== undefined)
            content_.append("PersonalData.ProgramId", personalData_ProgramId.toString());
        if (personalData_FirstName !== null && personalData_FirstName !== undefined)
            content_.append("PersonalData.FirstName", personalData_FirstName.toString());
        if (personalData_LastName !== null && personalData_LastName !== undefined)
            content_.append("PersonalData.LastName", personalData_LastName.toString());
        if (personalData_DateOfBirth !== null && personalData_DateOfBirth !== undefined)
            content_.append("PersonalData.DateOfBirth", personalData_DateOfBirth.toString());
        if (personalData_Gender !== null && personalData_Gender !== undefined)
            content_.append("PersonalData.Gender", personalData_Gender.toString());
        if (personalData_Street !== null && personalData_Street !== undefined)
            content_.append("PersonalData.Street", personalData_Street.toString());
        if (personalData_Zip !== null && personalData_Zip !== undefined)
            content_.append("PersonalData.Zip", personalData_Zip.toString());
        if (personalData_City !== null && personalData_City !== undefined)
            content_.append("PersonalData.City", personalData_City.toString());
        if (personalData_Phone !== null && personalData_Phone !== undefined)
            content_.append("PersonalData.Phone", personalData_Phone.toString());
        if (personalData_MobilePhone !== null && personalData_MobilePhone !== undefined)
            content_.append("PersonalData.MobilePhone", personalData_MobilePhone.toString());
        if (personalData_Email !== null && personalData_Email !== undefined)
            content_.append("PersonalData.Email", personalData_Email.toString());
        if (personalData_InsuranceId !== null && personalData_InsuranceId !== undefined)
            content_.append("PersonalData.InsuranceId", personalData_InsuranceId.toString());
        if (personalData_AeromedicalExaminer !== null && personalData_AeromedicalExaminer !== undefined)
            content_.append("PersonalData.AeromedicalExaminer", personalData_AeromedicalExaminer.toString());
        if (personalData_HealthInsurance !== null && personalData_HealthInsurance !== undefined)
            content_.append("PersonalData.HealthInsurance", personalData_HealthInsurance.toString());
        if (personalData_AirlineId !== null && personalData_AirlineId !== undefined)
            content_.append("PersonalData.AirlineId", personalData_AirlineId.toString());
        if (personalData_Fleet !== null && personalData_Fleet !== undefined)
            content_.append("PersonalData.Fleet", personalData_Fleet.toString());
        if (personalData_FunctionId !== null && personalData_FunctionId !== undefined)
            content_.append("PersonalData.FunctionId", personalData_FunctionId.toString());
        if (historyData_HistoryItemText !== null && historyData_HistoryItemText !== undefined)
            content_.append("HistoryData.HistoryItemText", historyData_HistoryItemText.toString());
        if (historyData_Files !== null && historyData_Files !== undefined)
            historyData_Files.forEach(item_ => content_.append("HistoryData.Files", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCase(_response);
        });
    }

    protected processCreateCase(response: AxiosResponse): Promise<ServiceResultOfGuid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfGuid.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfGuid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfGuid>(null as any);
    }

    getCase(query: GetCaseQuery, cancelToken?: CancelToken | undefined): Promise<CaseDto> {
        let url_ = this.baseUrl + "/api/Case/case";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCase(_response);
        });
    }

    protected processGetCase(response: AxiosResponse): Promise<CaseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CaseDto.fromJS(resultData200);
            return Promise.resolve<CaseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseDto>(null as any);
    }

    getCaseDataHistoryChanges(caseId: string, cancelToken?: CancelToken | undefined): Promise<DataHistoryChange[]> {
        let url_ = this.baseUrl + "/api/Case/case/change-dates/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseDataHistoryChanges(_response);
        });
    }

    protected processGetCaseDataHistoryChanges(response: AxiosResponse): Promise<DataHistoryChange[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataHistoryChange.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DataHistoryChange[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataHistoryChange[]>(null as any);
    }

    updateCasePersonalData(command: UpdateCasePersonalDataCommand, cancelToken?: CancelToken | undefined): Promise<ServiceResultOfCaseDto> {
        let url_ = this.baseUrl + "/api/Case/personal-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCasePersonalData(_response);
        });
    }

    protected processUpdateCasePersonalData(response: AxiosResponse): Promise<ServiceResultOfCaseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfCaseDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfCaseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfCaseDto>(null as any);
    }

    updateCaseResponsibility(command: UpdateCaseResponsibilityCommand, cancelToken?: CancelToken | undefined): Promise<ServiceResultOfCaseDto> {
        let url_ = this.baseUrl + "/api/Case/responsibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCaseResponsibility(_response);
        });
    }

    protected processUpdateCaseResponsibility(response: AxiosResponse): Promise<ServiceResultOfCaseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfCaseDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfCaseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfCaseDto>(null as any);
    }

    updateCaseClinicalInformation(command: UpdateCaseClinicalInformationCommand, cancelToken?: CancelToken | undefined): Promise<ServiceResultOfCaseClinicalInformationDto> {
        let url_ = this.baseUrl + "/api/Case/clinic-information";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCaseClinicalInformation(_response);
        });
    }

    protected processUpdateCaseClinicalInformation(response: AxiosResponse): Promise<ServiceResultOfCaseClinicalInformationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfCaseClinicalInformationDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfCaseClinicalInformationDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfCaseClinicalInformationDto>(null as any);
    }
}

export class FilesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7232";

    }

    downloadCaseFile(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Files/case/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCaseFile(_response);
        });
    }

    protected processDownloadCaseFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteCaseFile(id: string, cancelToken?: CancelToken | undefined): Promise<ServiceResult> {
        let url_ = this.baseUrl + "/api/Files/case/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCaseFile(_response);
        });
    }

    protected processDeleteCaseFile(response: AxiosResponse): Promise<ServiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResult.fromJS(resultData200);
            return Promise.resolve<ServiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResult>(null as any);
    }

    downloadLibraryFile(id: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Files/library/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadLibraryFile(_response);
        });
    }

    protected processDownloadLibraryFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteLibraryFile(id: string, cancelToken?: CancelToken | undefined): Promise<ServiceResult> {
        let url_ = this.baseUrl + "/api/Files/library/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLibraryFile(_response);
        });
    }

    protected processDeleteLibraryFile(response: AxiosResponse): Promise<ServiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResult.fromJS(resultData200);
            return Promise.resolve<ServiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResult>(null as any);
    }
}

export class GroupsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7232";

    }

    getGroups( cancelToken?: CancelToken | undefined): Promise<GroupDto[]> {
        let url_ = this.baseUrl + "/api/Groups/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroups(_response);
        });
    }

    protected processGetGroups(response: AxiosResponse): Promise<GroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GroupDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupDto[]>(null as any);
    }

    getGroupsLightInfo( cancelToken?: CancelToken | undefined): Promise<GroupLightDto[]> {
        let url_ = this.baseUrl + "/api/Groups/all-light";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroupsLightInfo(_response);
        });
    }

    protected processGetGroupsLightInfo(response: AxiosResponse): Promise<GroupLightDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupLightDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<GroupLightDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupLightDto[]>(null as any);
    }

    getGroupDetails(id: number, cancelToken?: CancelToken | undefined): Promise<GroupDetailsDto> {
        let url_ = this.baseUrl + "/api/Groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroupDetails(_response);
        });
    }

    protected processGetGroupDetails(response: AxiosResponse): Promise<GroupDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GroupDetailsDto.fromJS(resultData200);
            return Promise.resolve<GroupDetailsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupDetailsDto>(null as any);
    }

    getGroupMeetingDetails(groupId: number, meetingId: number, cancelToken?: CancelToken | undefined): Promise<GroupMeetingDetailsDto> {
        let url_ = this.baseUrl + "/api/Groups/group/{groupId}/meeting/{meetingId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroupMeetingDetails(_response);
        });
    }

    protected processGetGroupMeetingDetails(response: AxiosResponse): Promise<GroupMeetingDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GroupMeetingDetailsDto.fromJS(resultData200);
            return Promise.resolve<GroupMeetingDetailsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupMeetingDetailsDto>(null as any);
    }

    createGroup(command: CreateGroupCommand, cancelToken?: CancelToken | undefined): Promise<ServiceResultOfInteger> {
        let url_ = this.baseUrl + "/api/Groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGroup(_response);
        });
    }

    protected processCreateGroup(response: AxiosResponse): Promise<ServiceResultOfInteger> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfInteger.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfInteger>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfInteger>(null as any);
    }

    updateGroup(command: UpdateGroupCommand, cancelToken?: CancelToken | undefined): Promise<ServiceResult> {
        let url_ = this.baseUrl + "/api/Groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGroup(_response);
        });
    }

    protected processUpdateGroup(response: AxiosResponse): Promise<ServiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResult.fromJS(resultData200);
            return Promise.resolve<ServiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResult>(null as any);
    }

    createGroupMeeting(command: CreateGroupMeetingCommand, cancelToken?: CancelToken | undefined): Promise<GroupMeetingDto> {
        let url_ = this.baseUrl + "/api/Groups/meeting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGroupMeeting(_response);
        });
    }

    protected processCreateGroupMeeting(response: AxiosResponse): Promise<GroupMeetingDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GroupMeetingDto.fromJS(resultData200);
            return Promise.resolve<GroupMeetingDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupMeetingDto>(null as any);
    }

    updateGroupMeeting(dto: GroupMeetingDetailsDto, cancelToken?: CancelToken | undefined): Promise<GroupMeetingDetailsDto> {
        let url_ = this.baseUrl + "/api/Groups/meeting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGroupMeeting(_response);
        });
    }

    protected processUpdateGroupMeeting(response: AxiosResponse): Promise<GroupMeetingDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GroupMeetingDetailsDto.fromJS(resultData200);
            return Promise.resolve<GroupMeetingDetailsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GroupMeetingDetailsDto>(null as any);
    }

    cancelGroupMeeting(groupId: number, meetingId: number, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Groups/cancel-meeting/{groupId}/{meetingId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (meetingId === undefined || meetingId === null)
            throw new Error("The parameter 'meetingId' must be defined.");
        url_ = url_.replace("{meetingId}", encodeURIComponent("" + meetingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelGroupMeeting(_response);
        });
    }

    protected processCancelGroupMeeting(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class HealthClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7232";

    }

    get( cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class HistoryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7232";

    }

    getCaseHistory(caseId: string, cancelToken?: CancelToken | undefined): Promise<CaseHistoryDto> {
        let url_ = this.baseUrl + "/api/History/case/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseHistory(_response);
        });
    }

    protected processGetCaseHistory(response: AxiosResponse): Promise<CaseHistoryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CaseHistoryDto.fromJS(resultData200);
            return Promise.resolve<CaseHistoryDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseHistoryDto>(null as any);
    }

    getHistoryItem(id: string, cancelToken?: CancelToken | undefined): Promise<HistoryItemDto> {
        let url_ = this.baseUrl + "/api/History/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHistoryItem(_response);
        });
    }

    protected processGetHistoryItem(response: AxiosResponse): Promise<HistoryItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HistoryItemDto.fromJS(resultData200);
            return Promise.resolve<HistoryItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HistoryItemDto>(null as any);
    }

    getDocuments(caseId: string, cancelToken?: CancelToken | undefined): Promise<AntiSkidCaseFileDto[]> {
        let url_ = this.baseUrl + "/api/History/documents/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: AxiosResponse): Promise<AntiSkidCaseFileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AntiSkidCaseFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AntiSkidCaseFileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AntiSkidCaseFileDto[]>(null as any);
    }

    createHistoryItem(text: string | null | undefined, caseId: string | undefined, parentType: HistoryItemParentType | undefined, useSystemMessage: boolean | undefined, files: FileDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<ServiceResultOfHistoryItemDto> {
        let url_ = this.baseUrl + "/api/History/item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (text !== null && text !== undefined)
            content_.append("Text", text.toString());
        if (caseId === null || caseId === undefined)
            throw new Error("The parameter 'caseId' cannot be null.");
        else
            content_.append("CaseId", caseId.toString());
        if (parentType === null || parentType === undefined)
            throw new Error("The parameter 'parentType' cannot be null.");
        else
            content_.append("ParentType", parentType.toString());
        if (useSystemMessage === null || useSystemMessage === undefined)
            throw new Error("The parameter 'useSystemMessage' cannot be null.");
        else
            content_.append("UseSystemMessage", useSystemMessage.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateHistoryItem(_response);
        });
    }

    protected processCreateHistoryItem(response: AxiosResponse): Promise<ServiceResultOfHistoryItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfHistoryItemDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfHistoryItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfHistoryItemDto>(null as any);
    }

    updateHistoryItem(historyItemId: string | undefined, text: string | null | undefined, files: FileDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<HistoryItemDto> {
        let url_ = this.baseUrl + "/api/History/item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (historyItemId === null || historyItemId === undefined)
            throw new Error("The parameter 'historyItemId' cannot be null.");
        else
            content_.append("HistoryItemId", historyItemId.toString());
        if (text !== null && text !== undefined)
            content_.append("Text", text.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateHistoryItem(_response);
        });
    }

    protected processUpdateHistoryItem(response: AxiosResponse): Promise<HistoryItemDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HistoryItemDto.fromJS(resultData200);
            return Promise.resolve<HistoryItemDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HistoryItemDto>(null as any);
    }
}

export class IdentityClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7232";

    }

    login(command: LoginUserCommand, cancelToken?: CancelToken | undefined): Promise<AuthenticationResult> {
        let url_ = this.baseUrl + "/api/Identity/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<AuthenticationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticationResult.fromJS(resultData200);
            return Promise.resolve<AuthenticationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationResult>(null as any);
    }

    refresh(command: RefreshUserCommand, cancelToken?: CancelToken | undefined): Promise<AuthenticationResult> {
        let url_ = this.baseUrl + "/api/Identity/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: AxiosResponse): Promise<AuthenticationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticationResult.fromJS(resultData200);
            return Promise.resolve<AuthenticationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationResult>(null as any);
    }

    updatePassword(command: UpdatePasswordCommand, cancelToken?: CancelToken | undefined): Promise<ServiceResultOfAuthenticationResult> {
        let url_ = this.baseUrl + "/api/Identity/pass";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePassword(_response);
        });
    }

    protected processUpdatePassword(response: AxiosResponse): Promise<ServiceResultOfAuthenticationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfAuthenticationResult.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfAuthenticationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfAuthenticationResult>(null as any);
    }

    logout(command: LogoutUserCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Identity/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class LaboratoryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7232";

    }

    getCaseLaboratoryData(caseId: string, cancelToken?: CancelToken | undefined): Promise<CaseLaboratoryDataDto> {
        let url_ = this.baseUrl + "/api/Laboratory/{caseId}";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCaseLaboratoryData(_response);
        });
    }

    protected processGetCaseLaboratoryData(response: AxiosResponse): Promise<CaseLaboratoryDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CaseLaboratoryDataDto.fromJS(resultData200);
            return Promise.resolve<CaseLaboratoryDataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseLaboratoryDataDto>(null as any);
    }

    setCaseLaboratorySettings(command: SetCaseLaboratorySettingsCommand, cancelToken?: CancelToken | undefined): Promise<CaseLaboratoryDataDto> {
        let url_ = this.baseUrl + "/api/Laboratory/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetCaseLaboratorySettings(_response);
        });
    }

    protected processSetCaseLaboratorySettings(response: AxiosResponse): Promise<CaseLaboratoryDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CaseLaboratoryDataDto.fromJS(resultData200);
            return Promise.resolve<CaseLaboratoryDataDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseLaboratoryDataDto>(null as any);
    }

    deleteCaseLaboratoryTestResult(caseId: string, testResultId: string, cancelToken?: CancelToken | undefined): Promise<NextLabTestInfoDto> {
        let url_ = this.baseUrl + "/api/Laboratory/{caseId}/lab-test-result/{testResultId}";
        if (caseId === undefined || caseId === null)
            throw new Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (testResultId === undefined || testResultId === null)
            throw new Error("The parameter 'testResultId' must be defined.");
        url_ = url_.replace("{testResultId}", encodeURIComponent("" + testResultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCaseLaboratoryTestResult(_response);
        });
    }

    protected processDeleteCaseLaboratoryTestResult(response: AxiosResponse): Promise<NextLabTestInfoDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NextLabTestInfoDto.fromJS(resultData200);
            return Promise.resolve<NextLabTestInfoDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NextLabTestInfoDto>(null as any);
    }

    setCaseLaboratoryTestResult(id: string | null | undefined, caseId: string | undefined, testDate: string | null | undefined, gGT: number | undefined, gOT: number | undefined, gPT: number | undefined, doctorId: string | null | undefined, testResultTypeId: string | null | undefined, remarks: string | null | undefined, file_Id: string | null | undefined, file_Name: string | null | undefined, file_CategoryId: string | null | undefined, file_Description: string | null | undefined, file_File: FileParameter | null | undefined, cancelToken?: CancelToken | undefined): Promise<ServiceResultOfLaboratoryTestResultContainer> {
        let url_ = this.baseUrl + "/api/Laboratory/lab-test-result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (caseId === null || caseId === undefined)
            throw new Error("The parameter 'caseId' cannot be null.");
        else
            content_.append("CaseId", caseId.toString());
        if (testDate !== null && testDate !== undefined)
            content_.append("TestDate", testDate.toString());
        if (gGT === null || gGT === undefined)
            throw new Error("The parameter 'gGT' cannot be null.");
        else
            content_.append("GGT", gGT.toString());
        if (gOT === null || gOT === undefined)
            throw new Error("The parameter 'gOT' cannot be null.");
        else
            content_.append("GOT", gOT.toString());
        if (gPT === null || gPT === undefined)
            throw new Error("The parameter 'gPT' cannot be null.");
        else
            content_.append("GPT", gPT.toString());
        if (doctorId !== null && doctorId !== undefined)
            content_.append("DoctorId", doctorId.toString());
        if (testResultTypeId !== null && testResultTypeId !== undefined)
            content_.append("TestResultTypeId", testResultTypeId.toString());
        if (remarks !== null && remarks !== undefined)
            content_.append("Remarks", remarks.toString());
        if (file_Id !== null && file_Id !== undefined)
            content_.append("File.Id", file_Id.toString());
        if (file_Name !== null && file_Name !== undefined)
            content_.append("File.Name", file_Name.toString());
        if (file_CategoryId !== null && file_CategoryId !== undefined)
            content_.append("File.CategoryId", file_CategoryId.toString());
        if (file_Description !== null && file_Description !== undefined)
            content_.append("File.Description", file_Description.toString());
        if (file_File !== null && file_File !== undefined)
            content_.append("File.File", file_File.data, file_File.fileName ? file_File.fileName : "File.File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetCaseLaboratoryTestResult(_response);
        });
    }

    protected processSetCaseLaboratoryTestResult(response: AxiosResponse): Promise<ServiceResultOfLaboratoryTestResultContainer> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfLaboratoryTestResultContainer.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfLaboratoryTestResultContainer>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfLaboratoryTestResultContainer>(null as any);
    }
}

export class LibraryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7232";

    }

    getLibraryDocuments( cancelToken?: CancelToken | undefined): Promise<AntiSkidLibraryFileDto[]> {
        let url_ = this.baseUrl + "/api/Library/documents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLibraryDocuments(_response);
        });
    }

    protected processGetLibraryDocuments(response: AxiosResponse): Promise<AntiSkidLibraryFileDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AntiSkidLibraryFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AntiSkidLibraryFileDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AntiSkidLibraryFileDto[]>(null as any);
    }

    createLibraryDocument(files: FileDto[] | null | undefined, cancelToken?: CancelToken | undefined): Promise<ServiceResultOfListOfAntiSkidLibraryFileDto> {
        let url_ = this.baseUrl + "/api/Library";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.toString()));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLibraryDocument(_response);
        });
    }

    protected processCreateLibraryDocument(response: AxiosResponse): Promise<ServiceResultOfListOfAntiSkidLibraryFileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfListOfAntiSkidLibraryFileDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfListOfAntiSkidLibraryFileDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfListOfAntiSkidLibraryFileDto>(null as any);
    }
}

export class LookUpClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7232";

    }

    getLookUpValues(query: GetLookUpValuesQuery, cancelToken?: CancelToken | undefined): Promise<LookUpValueGroup[]> {
        let url_ = this.baseUrl + "/api/LookUp/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLookUpValues(_response);
        });
    }

    protected processGetLookUpValues(response: AxiosResponse): Promise<LookUpValueGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookUpValueGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LookUpValueGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LookUpValueGroup[]>(null as any);
    }

    create(command: CreateLookUpValueCommand, cancelToken?: CancelToken | undefined): Promise<ServiceResultOfLookUpValueDto> {
        let url_ = this.baseUrl + "/api/LookUp/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ServiceResultOfLookUpValueDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfLookUpValueDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfLookUpValueDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfLookUpValueDto>(null as any);
    }

    update(command: UpdateLookUpValueCommand, cancelToken?: CancelToken | undefined): Promise<ServiceResultOfLookUpValueDto> {
        let url_ = this.baseUrl + "/api/LookUp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ServiceResultOfLookUpValueDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfLookUpValueDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfLookUpValueDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfLookUpValueDto>(null as any);
    }

    reorderLookUpValues(command: UpdateLookUpValuesSortOrderCommand, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/LookUp/reOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReorderLookUpValues(_response);
        });
    }

    protected processReorderLookUpValues(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    delete(id: string, cancelToken?: CancelToken | undefined): Promise<ServiceResult> {
        let url_ = this.baseUrl + "/api/LookUp/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ServiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResult.fromJS(resultData200);
            return Promise.resolve<ServiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResult>(null as any);
    }
}

export class UserManagementClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:7232";

    }

    createUser(command: UpdateUserCommand, cancelToken?: CancelToken | undefined): Promise<ServiceResultOfInteger> {
        let url_ = this.baseUrl + "/api/UserManagement/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<ServiceResultOfInteger> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfInteger.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfInteger>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfInteger>(null as any);
    }

    updateUser(command: UpdateUserCommand, cancelToken?: CancelToken | undefined): Promise<ServiceResultOfUserDto> {
        let url_ = this.baseUrl + "/api/UserManagement/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<ServiceResultOfUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfUserDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfUserDto>(null as any);
    }

    getAppUsers(query: GetUsersQuery, cancelToken?: CancelToken | undefined): Promise<{ [key: string]: UserDto; }> {
        let url_ = this.baseUrl + "/api/UserManagement/app-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppUsers(_response);
        });
    }

    protected processGetAppUsers(response: AxiosResponse): Promise<{ [key: string]: UserDto; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? UserDto.fromJS(resultData200[key]) : new UserDto();
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: UserDto; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: UserDto; }>(null as any);
    }

    getUser(id: number, cancelToken?: CancelToken | undefined): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/UserManagement/user/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }
}

export class CaseFilters implements ICaseFilters {
    displayFilters?: FilterOfCaseDisplayType[] | undefined;
    years?: FilterOfInteger[] | undefined;
    programs?: FilterOfNullableGuid[] | undefined;
    groups?: FilterOfInteger[] | undefined;
    caseNumber?: string | undefined;

    constructor(data?: ICaseFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["displayFilters"])) {
                this.displayFilters = [] as any;
                for (let item of _data["displayFilters"])
                    this.displayFilters!.push(FilterOfCaseDisplayType.fromJS(item));
            }
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(FilterOfInteger.fromJS(item));
            }
            if (Array.isArray(_data["programs"])) {
                this.programs = [] as any;
                for (let item of _data["programs"])
                    this.programs!.push(FilterOfNullableGuid.fromJS(item));
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(FilterOfInteger.fromJS(item));
            }
            this.caseNumber = _data["caseNumber"];
        }
    }

    static fromJS(data: any): CaseFilters {
        data = typeof data === 'object' ? data : {};
        let result = new CaseFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.displayFilters)) {
            data["displayFilters"] = [];
            for (let item of this.displayFilters)
                data["displayFilters"].push(item.toJSON());
        }
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item.toJSON());
        }
        if (Array.isArray(this.programs)) {
            data["programs"] = [];
            for (let item of this.programs)
                data["programs"].push(item.toJSON());
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        data["caseNumber"] = this.caseNumber;
        return data;
    }
}

export interface ICaseFilters {
    displayFilters?: FilterOfCaseDisplayType[] | undefined;
    years?: FilterOfInteger[] | undefined;
    programs?: FilterOfNullableGuid[] | undefined;
    groups?: FilterOfInteger[] | undefined;
    caseNumber?: string | undefined;
}

export class FilterOfCaseDisplayType implements IFilterOfCaseDisplayType {
    label?: string | undefined;
    value?: CaseDisplayType;
    isSelected?: boolean;

    constructor(data?: IFilterOfCaseDisplayType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): FilterOfCaseDisplayType {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOfCaseDisplayType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IFilterOfCaseDisplayType {
    label?: string | undefined;
    value?: CaseDisplayType;
    isSelected?: boolean;
}

export enum CaseDisplayType {
    AllCases = "AllCases",
    MyCases = "MyCases",
    PipelineCases = "PipelineCases",
}

export class FilterOfInteger implements IFilterOfInteger {
    label?: string | undefined;
    value?: number;
    isSelected?: boolean;

    constructor(data?: IFilterOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): FilterOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IFilterOfInteger {
    label?: string | undefined;
    value?: number;
    isSelected?: boolean;
}

export class FilterOfNullableGuid implements IFilterOfNullableGuid {
    label?: string | undefined;
    value?: string | undefined;
    isSelected?: boolean;

    constructor(data?: IFilterOfNullableGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): FilterOfNullableGuid {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOfNullableGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IFilterOfNullableGuid {
    label?: string | undefined;
    value?: string | undefined;
    isSelected?: boolean;
}

export class CaseUsersDto implements ICaseUsersDto {
    caseUsers?: CaseUserDto[] | undefined;
    defaultUsers?: UserDto[] | undefined;

    constructor(data?: ICaseUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["caseUsers"])) {
                this.caseUsers = [] as any;
                for (let item of _data["caseUsers"])
                    this.caseUsers!.push(CaseUserDto.fromJS(item));
            }
            if (Array.isArray(_data["defaultUsers"])) {
                this.defaultUsers = [] as any;
                for (let item of _data["defaultUsers"])
                    this.defaultUsers!.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaseUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.caseUsers)) {
            data["caseUsers"] = [];
            for (let item of this.caseUsers)
                data["caseUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.defaultUsers)) {
            data["defaultUsers"] = [];
            for (let item of this.defaultUsers)
                data["defaultUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaseUsersDto {
    caseUsers?: CaseUserDto[] | undefined;
    defaultUsers?: UserDto[] | undefined;
}

export class CaseUserDto implements ICaseUserDto {
    id?: number;
    userId?: number;
    caseId?: string;
    caseRole?: CaseRoleType;
    isDeleted?: boolean;
    isAutoCreation?: boolean;

    constructor(data?: ICaseUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.caseId = _data["caseId"];
            this.caseRole = _data["caseRole"];
            this.isDeleted = _data["isDeleted"];
            this.isAutoCreation = _data["isAutoCreation"];
        }
    }

    static fromJS(data: any): CaseUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["caseId"] = this.caseId;
        data["caseRole"] = this.caseRole;
        data["isDeleted"] = this.isDeleted;
        data["isAutoCreation"] = this.isAutoCreation;
        return data;
    }
}

export interface ICaseUserDto {
    id?: number;
    userId?: number;
    caseId?: string;
    caseRole?: CaseRoleType;
    isDeleted?: boolean;
    isAutoCreation?: boolean;
}

export enum CaseRoleType {
    Readonly = "Readonly",
    Peer = "Peer",
    Therapist = "Therapist",
    SuperVisor = "SuperVisor",
    ClinicStaff = "ClinicStaff",
    Laboratory = "Laboratory",
    TechnicalSuperVisor = "TechnicalSuperVisor",
    FullAccess = "FullAccess",
}

export class UserDto implements IUserDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    claims?: string[] | undefined;
    roles?: string[] | undefined;
    city?: string | undefined;
    airline?: string | undefined;
    functionId?: string | undefined;
    nearestAirport?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.city = _data["city"];
            this.airline = _data["airline"];
            this.functionId = _data["functionId"];
            this.nearestAirport = _data["nearestAirport"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["city"] = this.city;
        data["airline"] = this.airline;
        data["functionId"] = this.functionId;
        data["nearestAirport"] = this.nearestAirport;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IUserDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    claims?: string[] | undefined;
    roles?: string[] | undefined;
    city?: string | undefined;
    airline?: string | undefined;
    functionId?: string | undefined;
    nearestAirport?: string | undefined;
    isDeleted?: boolean;
}

export class SetCaseUsersCommand implements ISetCaseUsersCommand {
    caseId?: string;
    caseUsers?: CaseUserDto[] | undefined;

    constructor(data?: ISetCaseUsersCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            if (Array.isArray(_data["caseUsers"])) {
                this.caseUsers = [] as any;
                for (let item of _data["caseUsers"])
                    this.caseUsers!.push(CaseUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetCaseUsersCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetCaseUsersCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        if (Array.isArray(this.caseUsers)) {
            data["caseUsers"] = [];
            for (let item of this.caseUsers)
                data["caseUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISetCaseUsersCommand {
    caseId?: string;
    caseUsers?: CaseUserDto[] | undefined;
}

export class CaseDto implements ICaseDto {
    caseData?: CaseDataDto | undefined;
    personalData?: CasePersonalDataDto | undefined;
    caseResponsibility?: CaseResponsibilityDto | undefined;
    caseClinicalInformation?: CaseClinicalInformationDto | undefined;
    nextTestingInfo?: NextLabTestInfoDto | undefined;
    created?: string;
    modified?: string | undefined;
    createdBy?: string | undefined;

    constructor(data?: ICaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseData = _data["caseData"] ? CaseDataDto.fromJS(_data["caseData"]) : <any>undefined;
            this.personalData = _data["personalData"] ? CasePersonalDataDto.fromJS(_data["personalData"]) : <any>undefined;
            this.caseResponsibility = _data["caseResponsibility"] ? CaseResponsibilityDto.fromJS(_data["caseResponsibility"]) : <any>undefined;
            this.caseClinicalInformation = _data["caseClinicalInformation"] ? CaseClinicalInformationDto.fromJS(_data["caseClinicalInformation"]) : <any>undefined;
            this.nextTestingInfo = _data["nextTestingInfo"] ? NextLabTestInfoDto.fromJS(_data["nextTestingInfo"]) : <any>undefined;
            this.created = _data["created"];
            this.modified = _data["modified"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): CaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseData"] = this.caseData ? this.caseData.toJSON() : <any>undefined;
        data["personalData"] = this.personalData ? this.personalData.toJSON() : <any>undefined;
        data["caseResponsibility"] = this.caseResponsibility ? this.caseResponsibility.toJSON() : <any>undefined;
        data["caseClinicalInformation"] = this.caseClinicalInformation ? this.caseClinicalInformation.toJSON() : <any>undefined;
        data["nextTestingInfo"] = this.nextTestingInfo ? this.nextTestingInfo.toJSON() : <any>undefined;
        data["created"] = this.created;
        data["modified"] = this.modified;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface ICaseDto {
    caseData?: CaseDataDto | undefined;
    personalData?: CasePersonalDataDto | undefined;
    caseResponsibility?: CaseResponsibilityDto | undefined;
    caseClinicalInformation?: CaseClinicalInformationDto | undefined;
    nextTestingInfo?: NextLabTestInfoDto | undefined;
    created?: string;
    modified?: string | undefined;
    createdBy?: string | undefined;
}

export class CaseDataDto implements ICaseDataDto {
    id?: string;
    caseNumber?: string | undefined;
    useLaboratory?: boolean;
    created?: string;
    modified?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: ICaseDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseNumber = _data["caseNumber"];
            this.useLaboratory = _data["useLaboratory"];
            this.created = _data["created"];
            this.modified = _data["modified"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CaseDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseNumber"] = this.caseNumber;
        data["useLaboratory"] = this.useLaboratory;
        data["created"] = this.created;
        data["modified"] = this.modified;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ICaseDataDto {
    id?: string;
    caseNumber?: string | undefined;
    useLaboratory?: boolean;
    created?: string;
    modified?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    isDeleted?: boolean;
}

export class CasePersonalDataDto implements ICasePersonalDataDto {
    id?: number | undefined;
    caseId?: string;
    pipelineCaseNumber?: string | undefined;
    programId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: string | undefined;
    gender?: GenderType | undefined;
    street?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    email?: string | undefined;
    insuranceId?: string | undefined;
    aeromedicalExaminer?: string | undefined;
    healthInsurance?: string | undefined;
    airlineId?: string | undefined;
    fleet?: string | undefined;
    functionId?: string | undefined;

    constructor(data?: ICasePersonalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.pipelineCaseNumber = _data["pipelineCaseNumber"];
            this.programId = _data["programId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.gender = _data["gender"];
            this.street = _data["street"];
            this.zip = _data["zip"];
            this.city = _data["city"];
            this.phone = _data["phone"];
            this.mobilePhone = _data["mobilePhone"];
            this.email = _data["email"];
            this.insuranceId = _data["insuranceId"];
            this.aeromedicalExaminer = _data["aeromedicalExaminer"];
            this.healthInsurance = _data["healthInsurance"];
            this.airlineId = _data["airlineId"];
            this.fleet = _data["fleet"];
            this.functionId = _data["functionId"];
        }
    }

    static fromJS(data: any): CasePersonalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CasePersonalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["pipelineCaseNumber"] = this.pipelineCaseNumber;
        data["programId"] = this.programId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dateOfBirth"] = this.dateOfBirth;
        data["gender"] = this.gender;
        data["street"] = this.street;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["phone"] = this.phone;
        data["mobilePhone"] = this.mobilePhone;
        data["email"] = this.email;
        data["insuranceId"] = this.insuranceId;
        data["aeromedicalExaminer"] = this.aeromedicalExaminer;
        data["healthInsurance"] = this.healthInsurance;
        data["airlineId"] = this.airlineId;
        data["fleet"] = this.fleet;
        data["functionId"] = this.functionId;
        return data;
    }
}

export interface ICasePersonalDataDto {
    id?: number | undefined;
    caseId?: string;
    pipelineCaseNumber?: string | undefined;
    programId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: string | undefined;
    gender?: GenderType | undefined;
    street?: string | undefined;
    zip?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    mobilePhone?: string | undefined;
    email?: string | undefined;
    insuranceId?: string | undefined;
    aeromedicalExaminer?: string | undefined;
    healthInsurance?: string | undefined;
    airlineId?: string | undefined;
    fleet?: string | undefined;
    functionId?: string | undefined;
}

export enum GenderType {
    None = "None",
    Unknown = "Unknown",
    Male = "Male",
    Female = "Female",
}

export class CaseResponsibilityDto implements ICaseResponsibilityDto {
    id?: number | undefined;
    caseId?: string;
    managerId?: number;
    firstContactDate?: string | undefined;
    firstContactAsPerson?: string | undefined;
    contactTypeId?: string | undefined;
    firstConsultationDate?: string | undefined;
    firstConsultationUsers?: number[] | undefined;
    secondConsultationDate?: string | undefined;
    secondConsultationUsers?: number[] | undefined;
    assessmentDate?: string | undefined;
    assessmentUsers?: number[] | undefined;
    medicalAgreementSignedDate?: string | undefined;
    medicalAgreementUsers?: number[] | undefined;

    constructor(data?: ICaseResponsibilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.managerId = _data["managerId"];
            this.firstContactDate = _data["firstContactDate"];
            this.firstContactAsPerson = _data["firstContactAsPerson"];
            this.contactTypeId = _data["contactTypeId"];
            this.firstConsultationDate = _data["firstConsultationDate"];
            if (Array.isArray(_data["firstConsultationUsers"])) {
                this.firstConsultationUsers = [] as any;
                for (let item of _data["firstConsultationUsers"])
                    this.firstConsultationUsers!.push(item);
            }
            this.secondConsultationDate = _data["secondConsultationDate"];
            if (Array.isArray(_data["secondConsultationUsers"])) {
                this.secondConsultationUsers = [] as any;
                for (let item of _data["secondConsultationUsers"])
                    this.secondConsultationUsers!.push(item);
            }
            this.assessmentDate = _data["assessmentDate"];
            if (Array.isArray(_data["assessmentUsers"])) {
                this.assessmentUsers = [] as any;
                for (let item of _data["assessmentUsers"])
                    this.assessmentUsers!.push(item);
            }
            this.medicalAgreementSignedDate = _data["medicalAgreementSignedDate"];
            if (Array.isArray(_data["medicalAgreementUsers"])) {
                this.medicalAgreementUsers = [] as any;
                for (let item of _data["medicalAgreementUsers"])
                    this.medicalAgreementUsers!.push(item);
            }
        }
    }

    static fromJS(data: any): CaseResponsibilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseResponsibilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["managerId"] = this.managerId;
        data["firstContactDate"] = this.firstContactDate;
        data["firstContactAsPerson"] = this.firstContactAsPerson;
        data["contactTypeId"] = this.contactTypeId;
        data["firstConsultationDate"] = this.firstConsultationDate;
        if (Array.isArray(this.firstConsultationUsers)) {
            data["firstConsultationUsers"] = [];
            for (let item of this.firstConsultationUsers)
                data["firstConsultationUsers"].push(item);
        }
        data["secondConsultationDate"] = this.secondConsultationDate;
        if (Array.isArray(this.secondConsultationUsers)) {
            data["secondConsultationUsers"] = [];
            for (let item of this.secondConsultationUsers)
                data["secondConsultationUsers"].push(item);
        }
        data["assessmentDate"] = this.assessmentDate;
        if (Array.isArray(this.assessmentUsers)) {
            data["assessmentUsers"] = [];
            for (let item of this.assessmentUsers)
                data["assessmentUsers"].push(item);
        }
        data["medicalAgreementSignedDate"] = this.medicalAgreementSignedDate;
        if (Array.isArray(this.medicalAgreementUsers)) {
            data["medicalAgreementUsers"] = [];
            for (let item of this.medicalAgreementUsers)
                data["medicalAgreementUsers"].push(item);
        }
        return data;
    }
}

export interface ICaseResponsibilityDto {
    id?: number | undefined;
    caseId?: string;
    managerId?: number;
    firstContactDate?: string | undefined;
    firstContactAsPerson?: string | undefined;
    contactTypeId?: string | undefined;
    firstConsultationDate?: string | undefined;
    firstConsultationUsers?: number[] | undefined;
    secondConsultationDate?: string | undefined;
    secondConsultationUsers?: number[] | undefined;
    assessmentDate?: string | undefined;
    assessmentUsers?: number[] | undefined;
    medicalAgreementSignedDate?: string | undefined;
    medicalAgreementUsers?: number[] | undefined;
}

export class CaseClinicalInformationDto implements ICaseClinicalInformationDto {
    id?: number | undefined;
    caseId?: string;
    advisorId?: number | undefined;
    therapistId?: number | undefined;
    mainDiagnose?: string | undefined;
    secondaryDiagnosis?: string[] | undefined;
    programStartDate?: string | undefined;
    plannedProgramEndDate?: string | undefined;
    aeromedicalExaminer?: string | undefined;
    aeromedicalFormer?: string | undefined;
    historyInputs?: HistoryInputDto[] | undefined;
    referenceNumbers?: string[] | undefined;
    medicalExpirationDate?: string | undefined;
    remarksAndRestrictions?: string | undefined;
    useLaboratory?: boolean;
    doctor?: string | undefined;
    useGroupMeetings?: boolean;
    groupId?: number | undefined;
    usedPsychotropics?: boolean;
    hospitalizationHistory?: HospitalizationHistoryDto[] | undefined;
    programEndDate?: string | undefined;
    isProgramSucceed?: boolean;
    programFailReasonId?: string | undefined;
    isLetterForLbaAvailable?: boolean;
    finalLetterSentDate?: string | undefined;
    followUpConsentId?: string | undefined;
    isFollowUpConsent?: boolean;
    remarks?: string | undefined;

    constructor(data?: ICaseClinicalInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.advisorId = _data["advisorId"];
            this.therapistId = _data["therapistId"];
            this.mainDiagnose = _data["mainDiagnose"];
            if (Array.isArray(_data["secondaryDiagnosis"])) {
                this.secondaryDiagnosis = [] as any;
                for (let item of _data["secondaryDiagnosis"])
                    this.secondaryDiagnosis!.push(item);
            }
            this.programStartDate = _data["programStartDate"];
            this.plannedProgramEndDate = _data["plannedProgramEndDate"];
            this.aeromedicalExaminer = _data["aeromedicalExaminer"];
            this.aeromedicalFormer = _data["aeromedicalFormer"];
            if (Array.isArray(_data["historyInputs"])) {
                this.historyInputs = [] as any;
                for (let item of _data["historyInputs"])
                    this.historyInputs!.push(HistoryInputDto.fromJS(item));
            }
            if (Array.isArray(_data["referenceNumbers"])) {
                this.referenceNumbers = [] as any;
                for (let item of _data["referenceNumbers"])
                    this.referenceNumbers!.push(item);
            }
            this.medicalExpirationDate = _data["medicalExpirationDate"];
            this.remarksAndRestrictions = _data["remarksAndRestrictions"];
            this.useLaboratory = _data["useLaboratory"];
            this.doctor = _data["doctor"];
            this.useGroupMeetings = _data["useGroupMeetings"];
            this.groupId = _data["groupId"];
            this.usedPsychotropics = _data["usedPsychotropics"];
            if (Array.isArray(_data["hospitalizationHistory"])) {
                this.hospitalizationHistory = [] as any;
                for (let item of _data["hospitalizationHistory"])
                    this.hospitalizationHistory!.push(HospitalizationHistoryDto.fromJS(item));
            }
            this.programEndDate = _data["programEndDate"];
            this.isProgramSucceed = _data["isProgramSucceed"];
            this.programFailReasonId = _data["programFailReasonId"];
            this.isLetterForLbaAvailable = _data["isLetterForLbaAvailable"];
            this.finalLetterSentDate = _data["finalLetterSentDate"];
            this.followUpConsentId = _data["followUpConsentId"];
            this.isFollowUpConsent = _data["isFollowUpConsent"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): CaseClinicalInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseClinicalInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["advisorId"] = this.advisorId;
        data["therapistId"] = this.therapistId;
        data["mainDiagnose"] = this.mainDiagnose;
        if (Array.isArray(this.secondaryDiagnosis)) {
            data["secondaryDiagnosis"] = [];
            for (let item of this.secondaryDiagnosis)
                data["secondaryDiagnosis"].push(item);
        }
        data["programStartDate"] = this.programStartDate;
        data["plannedProgramEndDate"] = this.plannedProgramEndDate;
        data["aeromedicalExaminer"] = this.aeromedicalExaminer;
        data["aeromedicalFormer"] = this.aeromedicalFormer;
        if (Array.isArray(this.historyInputs)) {
            data["historyInputs"] = [];
            for (let item of this.historyInputs)
                data["historyInputs"].push(item.toJSON());
        }
        if (Array.isArray(this.referenceNumbers)) {
            data["referenceNumbers"] = [];
            for (let item of this.referenceNumbers)
                data["referenceNumbers"].push(item);
        }
        data["medicalExpirationDate"] = this.medicalExpirationDate;
        data["remarksAndRestrictions"] = this.remarksAndRestrictions;
        data["useLaboratory"] = this.useLaboratory;
        data["doctor"] = this.doctor;
        data["useGroupMeetings"] = this.useGroupMeetings;
        data["groupId"] = this.groupId;
        data["usedPsychotropics"] = this.usedPsychotropics;
        if (Array.isArray(this.hospitalizationHistory)) {
            data["hospitalizationHistory"] = [];
            for (let item of this.hospitalizationHistory)
                data["hospitalizationHistory"].push(item.toJSON());
        }
        data["programEndDate"] = this.programEndDate;
        data["isProgramSucceed"] = this.isProgramSucceed;
        data["programFailReasonId"] = this.programFailReasonId;
        data["isLetterForLbaAvailable"] = this.isLetterForLbaAvailable;
        data["finalLetterSentDate"] = this.finalLetterSentDate;
        data["followUpConsentId"] = this.followUpConsentId;
        data["isFollowUpConsent"] = this.isFollowUpConsent;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface ICaseClinicalInformationDto {
    id?: number | undefined;
    caseId?: string;
    advisorId?: number | undefined;
    therapistId?: number | undefined;
    mainDiagnose?: string | undefined;
    secondaryDiagnosis?: string[] | undefined;
    programStartDate?: string | undefined;
    plannedProgramEndDate?: string | undefined;
    aeromedicalExaminer?: string | undefined;
    aeromedicalFormer?: string | undefined;
    historyInputs?: HistoryInputDto[] | undefined;
    referenceNumbers?: string[] | undefined;
    medicalExpirationDate?: string | undefined;
    remarksAndRestrictions?: string | undefined;
    useLaboratory?: boolean;
    doctor?: string | undefined;
    useGroupMeetings?: boolean;
    groupId?: number | undefined;
    usedPsychotropics?: boolean;
    hospitalizationHistory?: HospitalizationHistoryDto[] | undefined;
    programEndDate?: string | undefined;
    isProgramSucceed?: boolean;
    programFailReasonId?: string | undefined;
    isLetterForLbaAvailable?: boolean;
    finalLetterSentDate?: string | undefined;
    followUpConsentId?: string | undefined;
    isFollowUpConsent?: boolean;
    remarks?: string | undefined;
}

export class HistoryInputDto implements IHistoryInputDto {
    id?: number | undefined;
    date?: string | undefined;
    historyInputTypeId?: string | undefined;
    createdDate?: string | undefined;

    constructor(data?: IHistoryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"];
            this.historyInputTypeId = _data["historyInputTypeId"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): HistoryInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date;
        data["historyInputTypeId"] = this.historyInputTypeId;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IHistoryInputDto {
    id?: number | undefined;
    date?: string | undefined;
    historyInputTypeId?: string | undefined;
    createdDate?: string | undefined;
}

export class HospitalizationHistoryDto implements IHospitalizationHistoryDto {
    id?: number | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    hospitalizationTypeId?: string | undefined;
    createdDate?: string | undefined;

    constructor(data?: IHospitalizationHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.hospitalizationTypeId = _data["hospitalizationTypeId"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): HospitalizationHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new HospitalizationHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["hospitalizationTypeId"] = this.hospitalizationTypeId;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IHospitalizationHistoryDto {
    id?: number | undefined;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    hospitalizationTypeId?: string | undefined;
    createdDate?: string | undefined;
}

export class NextLabTestInfoDto implements INextLabTestInfoDto {
    nextLaboratoryTestDate?: string | undefined;
    isNextTestOverdue?: boolean;

    constructor(data?: INextLabTestInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextLaboratoryTestDate = _data["nextLaboratoryTestDate"];
            this.isNextTestOverdue = _data["isNextTestOverdue"];
        }
    }

    static fromJS(data: any): NextLabTestInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new NextLabTestInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextLaboratoryTestDate"] = this.nextLaboratoryTestDate;
        data["isNextTestOverdue"] = this.isNextTestOverdue;
        return data;
    }
}

export interface INextLabTestInfoDto {
    nextLaboratoryTestDate?: string | undefined;
    isNextTestOverdue?: boolean;
}

export class GetCasesQuery implements IGetCasesQuery {
    displayFilter?: CaseDisplayType;
    years?: number[] | undefined;
    programs?: string[] | undefined;
    groups?: number[] | undefined;
    caseNumber?: string | undefined;

    constructor(data?: IGetCasesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayFilter = _data["displayFilter"];
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(item);
            }
            if (Array.isArray(_data["programs"])) {
                this.programs = [] as any;
                for (let item of _data["programs"])
                    this.programs!.push(item);
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
            this.caseNumber = _data["caseNumber"];
        }
    }

    static fromJS(data: any): GetCasesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCasesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayFilter"] = this.displayFilter;
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item);
        }
        if (Array.isArray(this.programs)) {
            data["programs"] = [];
            for (let item of this.programs)
                data["programs"].push(item);
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["caseNumber"] = this.caseNumber;
        return data;
    }
}

export interface IGetCasesQuery {
    displayFilter?: CaseDisplayType;
    years?: number[] | undefined;
    programs?: string[] | undefined;
    groups?: number[] | undefined;
    caseNumber?: string | undefined;
}

export class ServiceResult implements IServiceResult {
    errors?: string[] | undefined;
    errorCode?: number;
    isSuccess?: boolean;

    constructor(data?: IServiceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.errorCode = _data["errorCode"];
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): ServiceResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["errorCode"] = this.errorCode;
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IServiceResult {
    errors?: string[] | undefined;
    errorCode?: number;
    isSuccess?: boolean;
}

export class ServiceResultOfGuid extends ServiceResult implements IServiceResultOfGuid {
    entity?: string;

    constructor(data?: IServiceResultOfGuid) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"];
        }
    }

    static override fromJS(data: any): ServiceResultOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfGuid();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfGuid extends IServiceResult {
    entity?: string;
}

export class FileDto implements IFileDto {
    id?: string | undefined;
    name?: string | undefined;
    categoryId?: string | undefined;
    description?: string | undefined;
    file?: string | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.description = _data["description"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["description"] = this.description;
        data["file"] = this.file;
        return data;
    }
}

export interface IFileDto {
    id?: string | undefined;
    name?: string | undefined;
    categoryId?: string | undefined;
    description?: string | undefined;
    file?: string | undefined;
}

export class GetCaseQuery implements IGetCaseQuery {
    caseId?: string;
    periodStart?: string | undefined;
    periodEnd?: string | undefined;

    constructor(data?: IGetCaseQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.periodStart = _data["periodStart"];
            this.periodEnd = _data["periodEnd"];
        }
    }

    static fromJS(data: any): GetCaseQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetCaseQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["periodStart"] = this.periodStart;
        data["periodEnd"] = this.periodEnd;
        return data;
    }
}

export interface IGetCaseQuery {
    caseId?: string;
    periodStart?: string | undefined;
    periodEnd?: string | undefined;
}

export class DataHistoryChange implements IDataHistoryChange {
    periodStart?: string | undefined;
    periodEnd?: string | undefined;
    changedBy?: number;

    constructor(data?: IDataHistoryChange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodStart = _data["periodStart"];
            this.periodEnd = _data["periodEnd"];
            this.changedBy = _data["changedBy"];
        }
    }

    static fromJS(data: any): DataHistoryChange {
        data = typeof data === 'object' ? data : {};
        let result = new DataHistoryChange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodStart"] = this.periodStart;
        data["periodEnd"] = this.periodEnd;
        data["changedBy"] = this.changedBy;
        return data;
    }
}

export interface IDataHistoryChange {
    periodStart?: string | undefined;
    periodEnd?: string | undefined;
    changedBy?: number;
}

export class ServiceResultOfCaseDto extends ServiceResult implements IServiceResultOfCaseDto {
    entity?: CaseDto | undefined;

    constructor(data?: IServiceResultOfCaseDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"] ? CaseDto.fromJS(_data["entity"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServiceResultOfCaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfCaseDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfCaseDto extends IServiceResult {
    entity?: CaseDto | undefined;
}

export class UpdateCasePersonalDataCommand implements IUpdateCasePersonalDataCommand {
    personalData?: CasePersonalDataDto | undefined;

    constructor(data?: IUpdateCasePersonalDataCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalData = _data["personalData"] ? CasePersonalDataDto.fromJS(_data["personalData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCasePersonalDataCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCasePersonalDataCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalData"] = this.personalData ? this.personalData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCasePersonalDataCommand {
    personalData?: CasePersonalDataDto | undefined;
}

export class UpdateCaseResponsibilityCommand implements IUpdateCaseResponsibilityCommand {
    caseResponsibility?: CaseResponsibilityDto | undefined;

    constructor(data?: IUpdateCaseResponsibilityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseResponsibility = _data["caseResponsibility"] ? CaseResponsibilityDto.fromJS(_data["caseResponsibility"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCaseResponsibilityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseResponsibilityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseResponsibility"] = this.caseResponsibility ? this.caseResponsibility.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCaseResponsibilityCommand {
    caseResponsibility?: CaseResponsibilityDto | undefined;
}

export class ServiceResultOfCaseClinicalInformationDto extends ServiceResult implements IServiceResultOfCaseClinicalInformationDto {
    entity?: CaseClinicalInformationDto | undefined;

    constructor(data?: IServiceResultOfCaseClinicalInformationDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"] ? CaseClinicalInformationDto.fromJS(_data["entity"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServiceResultOfCaseClinicalInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfCaseClinicalInformationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfCaseClinicalInformationDto extends IServiceResult {
    entity?: CaseClinicalInformationDto | undefined;
}

export class UpdateCaseClinicalInformationCommand implements IUpdateCaseClinicalInformationCommand {
    caseClinicalInformation?: CaseClinicalInformationDto | undefined;

    constructor(data?: IUpdateCaseClinicalInformationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseClinicalInformation = _data["caseClinicalInformation"] ? CaseClinicalInformationDto.fromJS(_data["caseClinicalInformation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCaseClinicalInformationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaseClinicalInformationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseClinicalInformation"] = this.caseClinicalInformation ? this.caseClinicalInformation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateCaseClinicalInformationCommand {
    caseClinicalInformation?: CaseClinicalInformationDto | undefined;
}

export class GroupDto implements IGroupDto {
    id?: number;
    name?: string | undefined;
    meetingsCount?: number;
    membersCount?: number;
    previousMeetingDate?: string | undefined;
    nextMeetingDate?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.meetingsCount = _data["meetingsCount"];
            this.membersCount = _data["membersCount"];
            this.previousMeetingDate = _data["previousMeetingDate"];
            this.nextMeetingDate = _data["nextMeetingDate"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): GroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["meetingsCount"] = this.meetingsCount;
        data["membersCount"] = this.membersCount;
        data["previousMeetingDate"] = this.previousMeetingDate;
        data["nextMeetingDate"] = this.nextMeetingDate;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IGroupDto {
    id?: number;
    name?: string | undefined;
    meetingsCount?: number;
    membersCount?: number;
    previousMeetingDate?: string | undefined;
    nextMeetingDate?: string | undefined;
    isDeleted?: boolean;
}

export class GroupLightDto implements IGroupLightDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IGroupLightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GroupLightDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupLightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGroupLightDto {
    id?: number;
    name?: string | undefined;
}

export class GroupDetailsDto implements IGroupDetailsDto {
    id?: number;
    name?: string | undefined;
    organizerId?: number;
    isDeleted?: boolean;
    meetings?: GroupMeetingDto[] | undefined;
    members?: GroupMemberDto[] | undefined;

    constructor(data?: IGroupDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizerId = _data["organizerId"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["meetings"])) {
                this.meetings = [] as any;
                for (let item of _data["meetings"])
                    this.meetings!.push(GroupMeetingDto.fromJS(item));
            }
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(GroupMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizerId"] = this.organizerId;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.meetings)) {
            data["meetings"] = [];
            for (let item of this.meetings)
                data["meetings"].push(item.toJSON());
        }
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroupDetailsDto {
    id?: number;
    name?: string | undefined;
    organizerId?: number;
    isDeleted?: boolean;
    meetings?: GroupMeetingDto[] | undefined;
    members?: GroupMemberDto[] | undefined;
}

export class GroupMeetingDto implements IGroupMeetingDto {
    id?: number;
    groupId?: number;
    meetingDate?: string;
    membersCount?: number;
    meetingTypeId?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IGroupMeetingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.meetingDate = _data["meetingDate"];
            this.membersCount = _data["membersCount"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): GroupMeetingDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupMeetingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["meetingDate"] = this.meetingDate;
        data["membersCount"] = this.membersCount;
        data["meetingTypeId"] = this.meetingTypeId;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IGroupMeetingDto {
    id?: number;
    groupId?: number;
    meetingDate?: string;
    membersCount?: number;
    meetingTypeId?: string | undefined;
    isDeleted?: boolean;
}

export class GroupMemberDto implements IGroupMemberDto {
    id?: number;
    caseId?: string;
    caseNumber?: string | undefined;
    caseManagerId?: number;
    therapistId?: number | undefined;

    constructor(data?: IGroupMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.caseNumber = _data["caseNumber"];
            this.caseManagerId = _data["caseManagerId"];
            this.therapistId = _data["therapistId"];
        }
    }

    static fromJS(data: any): GroupMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["caseNumber"] = this.caseNumber;
        data["caseManagerId"] = this.caseManagerId;
        data["therapistId"] = this.therapistId;
        return data;
    }
}

export interface IGroupMemberDto {
    id?: number;
    caseId?: string;
    caseNumber?: string | undefined;
    caseManagerId?: number;
    therapistId?: number | undefined;
}

export class GroupMeetingDetailsDto implements IGroupMeetingDetailsDto {
    id?: number;
    groupId?: number;
    groupName?: string | undefined;
    meetingDate?: string;
    meetingTypeId?: string | undefined;
    notes?: string | undefined;
    isDeleted?: boolean;
    meetingMembers?: GroupMeetingMemberDto[] | undefined;

    constructor(data?: IGroupMeetingDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.meetingDate = _data["meetingDate"];
            this.meetingTypeId = _data["meetingTypeId"];
            this.notes = _data["notes"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["meetingMembers"])) {
                this.meetingMembers = [] as any;
                for (let item of _data["meetingMembers"])
                    this.meetingMembers!.push(GroupMeetingMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupMeetingDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupMeetingDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["meetingDate"] = this.meetingDate;
        data["meetingTypeId"] = this.meetingTypeId;
        data["notes"] = this.notes;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.meetingMembers)) {
            data["meetingMembers"] = [];
            for (let item of this.meetingMembers)
                data["meetingMembers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroupMeetingDetailsDto {
    id?: number;
    groupId?: number;
    groupName?: string | undefined;
    meetingDate?: string;
    meetingTypeId?: string | undefined;
    notes?: string | undefined;
    isDeleted?: boolean;
    meetingMembers?: GroupMeetingMemberDto[] | undefined;
}

export class GroupMeetingMemberDto implements IGroupMeetingMemberDto {
    id?: number;
    groupMemberId?: number;
    groupMeetingId?: number;
    historyItem?: HistoryItemDto | undefined;
    caseId?: string;
    caseNumber?: string | undefined;

    constructor(data?: IGroupMeetingMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupMemberId = _data["groupMemberId"];
            this.groupMeetingId = _data["groupMeetingId"];
            this.historyItem = _data["historyItem"] ? HistoryItemDto.fromJS(_data["historyItem"]) : <any>undefined;
            this.caseId = _data["caseId"];
            this.caseNumber = _data["caseNumber"];
        }
    }

    static fromJS(data: any): GroupMeetingMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupMeetingMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupMemberId"] = this.groupMemberId;
        data["groupMeetingId"] = this.groupMeetingId;
        data["historyItem"] = this.historyItem ? this.historyItem.toJSON() : <any>undefined;
        data["caseId"] = this.caseId;
        data["caseNumber"] = this.caseNumber;
        return data;
    }
}

export interface IGroupMeetingMemberDto {
    id?: number;
    groupMemberId?: number;
    groupMeetingId?: number;
    historyItem?: HistoryItemDto | undefined;
    caseId?: string;
    caseNumber?: string | undefined;
}

export class HistoryItemDto implements IHistoryItemDto {
    id?: string;
    caseId?: string;
    created?: string;
    modified?: string | undefined;
    createdByUserId?: number;
    createdUserFullName?: string | undefined;
    parentType?: HistoryItemParentType;
    text?: string | undefined;
    meetingStatus?: MeetingStatus | undefined;
    groupId?: number;
    groupMeetingId?: number;
    files?: AntiSkidCaseFileDto[] | undefined;

    constructor(data?: IHistoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.created = _data["created"];
            this.modified = _data["modified"];
            this.createdByUserId = _data["createdByUserId"];
            this.createdUserFullName = _data["createdUserFullName"];
            this.parentType = _data["parentType"];
            this.text = _data["text"];
            this.meetingStatus = _data["meetingStatus"];
            this.groupId = _data["groupId"];
            this.groupMeetingId = _data["groupMeetingId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(AntiSkidCaseFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HistoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["created"] = this.created;
        data["modified"] = this.modified;
        data["createdByUserId"] = this.createdByUserId;
        data["createdUserFullName"] = this.createdUserFullName;
        data["parentType"] = this.parentType;
        data["text"] = this.text;
        data["meetingStatus"] = this.meetingStatus;
        data["groupId"] = this.groupId;
        data["groupMeetingId"] = this.groupMeetingId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHistoryItemDto {
    id?: string;
    caseId?: string;
    created?: string;
    modified?: string | undefined;
    createdByUserId?: number;
    createdUserFullName?: string | undefined;
    parentType?: HistoryItemParentType;
    text?: string | undefined;
    meetingStatus?: MeetingStatus | undefined;
    groupId?: number;
    groupMeetingId?: number;
    files?: AntiSkidCaseFileDto[] | undefined;
}

export enum HistoryItemParentType {
    None = "None",
    Case = "Case",
    Document = "Document",
    Meeting = "Meeting",
}

export enum MeetingStatus {
    None = "None",
    Excused = "Excused",
    NotExcused = "NotExcused",
}

export abstract class AntiSkidFileBaseDto implements IAntiSkidFileBaseDto {
    id?: string;
    name?: string | undefined;
    categoryId?: string | undefined;
    description?: string | undefined;
    created?: string;
    createdBy?: string | undefined;

    constructor(data?: IAntiSkidFileBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryId = _data["categoryId"];
            this.description = _data["description"];
            this.created = _data["created"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): AntiSkidFileBaseDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'AntiSkidFileBaseDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryId"] = this.categoryId;
        data["description"] = this.description;
        data["created"] = this.created;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IAntiSkidFileBaseDto {
    id?: string;
    name?: string | undefined;
    categoryId?: string | undefined;
    description?: string | undefined;
    created?: string;
    createdBy?: string | undefined;
}

export class AntiSkidCaseFileDto extends AntiSkidFileBaseDto implements IAntiSkidCaseFileDto {
    caseId?: string;
    additionalParentId?: string;

    constructor(data?: IAntiSkidCaseFileDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.caseId = _data["caseId"];
            this.additionalParentId = _data["additionalParentId"];
        }
    }

    static override fromJS(data: any): AntiSkidCaseFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new AntiSkidCaseFileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["additionalParentId"] = this.additionalParentId;
        super.toJSON(data);
        return data;
    }
}

export interface IAntiSkidCaseFileDto extends IAntiSkidFileBaseDto {
    caseId?: string;
    additionalParentId?: string;
}

export class ServiceResultOfInteger extends ServiceResult implements IServiceResultOfInteger {
    entity?: number;

    constructor(data?: IServiceResultOfInteger) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"];
        }
    }

    static override fromJS(data: any): ServiceResultOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfInteger();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfInteger extends IServiceResult {
    entity?: number;
}

export class CreateGroupCommand implements ICreateGroupCommand {
    groupName?: string | undefined;
    groupOrganizerId?: number;

    constructor(data?: ICreateGroupCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            this.groupOrganizerId = _data["groupOrganizerId"];
        }
    }

    static fromJS(data: any): CreateGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        data["groupOrganizerId"] = this.groupOrganizerId;
        return data;
    }
}

export interface ICreateGroupCommand {
    groupName?: string | undefined;
    groupOrganizerId?: number;
}

export class UpdateGroupCommand extends CreateGroupCommand implements IUpdateGroupCommand {
    groupId?: number;

    constructor(data?: IUpdateGroupCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.groupId = _data["groupId"];
        }
    }

    static override fromJS(data: any): UpdateGroupCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGroupCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateGroupCommand extends ICreateGroupCommand {
    groupId?: number;
}

export class CreateGroupMeetingCommand implements ICreateGroupMeetingCommand {
    groupId?: number;
    meetingDate?: string;
    meetingTypeId?: string | undefined;

    constructor(data?: ICreateGroupMeetingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.meetingDate = _data["meetingDate"];
            this.meetingTypeId = _data["meetingTypeId"];
        }
    }

    static fromJS(data: any): CreateGroupMeetingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupMeetingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["meetingDate"] = this.meetingDate;
        data["meetingTypeId"] = this.meetingTypeId;
        return data;
    }
}

export interface ICreateGroupMeetingCommand {
    groupId?: number;
    meetingDate?: string;
    meetingTypeId?: string | undefined;
}

export class CaseHistoryDto implements ICaseHistoryDto {
    historyItems?: HistoryItemDto[] | undefined;

    constructor(data?: ICaseHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["historyItems"])) {
                this.historyItems = [] as any;
                for (let item of _data["historyItems"])
                    this.historyItems!.push(HistoryItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaseHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.historyItems)) {
            data["historyItems"] = [];
            for (let item of this.historyItems)
                data["historyItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaseHistoryDto {
    historyItems?: HistoryItemDto[] | undefined;
}

export class ServiceResultOfHistoryItemDto extends ServiceResult implements IServiceResultOfHistoryItemDto {
    entity?: HistoryItemDto | undefined;

    constructor(data?: IServiceResultOfHistoryItemDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"] ? HistoryItemDto.fromJS(_data["entity"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServiceResultOfHistoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfHistoryItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfHistoryItemDto extends IServiceResult {
    entity?: HistoryItemDto | undefined;
}

export class AuthenticationResult implements IAuthenticationResult {
    token?: string | undefined;
    refreshToken?: string | undefined;
    isSuccess?: boolean;
    errorMessages?: string[] | undefined;

    constructor(data?: IAuthenticationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
        }
    }

    static fromJS(data: any): AuthenticationResult {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}

export interface IAuthenticationResult {
    token?: string | undefined;
    refreshToken?: string | undefined;
    isSuccess?: boolean;
    errorMessages?: string[] | undefined;
}

export class LoginUserCommand implements ILoginUserCommand {
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LoginUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginUserCommand {
    email?: string | undefined;
    password?: string | undefined;
}

export class RefreshUserCommand implements IRefreshUserCommand {
    token?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshUserCommand {
    token?: string | undefined;
    refreshToken?: string | undefined;
}

export class ServiceResultOfAuthenticationResult extends ServiceResult implements IServiceResultOfAuthenticationResult {
    entity?: AuthenticationResult | undefined;

    constructor(data?: IServiceResultOfAuthenticationResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"] ? AuthenticationResult.fromJS(_data["entity"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServiceResultOfAuthenticationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfAuthenticationResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfAuthenticationResult extends IServiceResult {
    entity?: AuthenticationResult | undefined;
}

export class UpdatePasswordCommand implements IUpdatePasswordCommand {
    userId?: number;
    oldPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IUpdatePasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): UpdatePasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IUpdatePasswordCommand {
    userId?: number;
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class LogoutUserCommand implements ILogoutUserCommand {
    refreshToken?: string | undefined;

    constructor(data?: ILogoutUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): LogoutUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LogoutUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface ILogoutUserCommand {
    refreshToken?: string | undefined;
}

export class CaseLaboratoryDataDto implements ICaseLaboratoryDataDto {
    laboratorySettings?: CaseLaboratorySettingsDto | undefined;
    nextLabTestInfo?: NextLabTestInfoDto | undefined;
    testResults?: LaboratoryTestResultDto[] | undefined;

    constructor(data?: ICaseLaboratoryDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.laboratorySettings = _data["laboratorySettings"] ? CaseLaboratorySettingsDto.fromJS(_data["laboratorySettings"]) : <any>undefined;
            this.nextLabTestInfo = _data["nextLabTestInfo"] ? NextLabTestInfoDto.fromJS(_data["nextLabTestInfo"]) : <any>undefined;
            if (Array.isArray(_data["testResults"])) {
                this.testResults = [] as any;
                for (let item of _data["testResults"])
                    this.testResults!.push(LaboratoryTestResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CaseLaboratoryDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseLaboratoryDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["laboratorySettings"] = this.laboratorySettings ? this.laboratorySettings.toJSON() : <any>undefined;
        data["nextLabTestInfo"] = this.nextLabTestInfo ? this.nextLabTestInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.testResults)) {
            data["testResults"] = [];
            for (let item of this.testResults)
                data["testResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICaseLaboratoryDataDto {
    laboratorySettings?: CaseLaboratorySettingsDto | undefined;
    nextLabTestInfo?: NextLabTestInfoDto | undefined;
    testResults?: LaboratoryTestResultDto[] | undefined;
}

export class CaseLaboratorySettingsDto implements ICaseLaboratorySettingsDto {
    id?: number;
    caseId?: string;
    firstTestDate?: string | undefined;
    testTypes?: string[] | undefined;
    monthsInterval?: number;

    constructor(data?: ICaseLaboratorySettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseId = _data["caseId"];
            this.firstTestDate = _data["firstTestDate"];
            if (Array.isArray(_data["testTypes"])) {
                this.testTypes = [] as any;
                for (let item of _data["testTypes"])
                    this.testTypes!.push(item);
            }
            this.monthsInterval = _data["monthsInterval"];
        }
    }

    static fromJS(data: any): CaseLaboratorySettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaseLaboratorySettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseId"] = this.caseId;
        data["firstTestDate"] = this.firstTestDate;
        if (Array.isArray(this.testTypes)) {
            data["testTypes"] = [];
            for (let item of this.testTypes)
                data["testTypes"].push(item);
        }
        data["monthsInterval"] = this.monthsInterval;
        return data;
    }
}

export interface ICaseLaboratorySettingsDto {
    id?: number;
    caseId?: string;
    firstTestDate?: string | undefined;
    testTypes?: string[] | undefined;
    monthsInterval?: number;
}

export class LaboratoryTestResultDto implements ILaboratoryTestResultDto {
    id?: string;
    caseLaboratorySettingsId?: number;
    testDate?: string | undefined;
    ggt?: number | undefined;
    got?: number | undefined;
    gpt?: number | undefined;
    testResultTypeId?: string | undefined;
    testResultType?: LookUpValueDto | undefined;
    doctorId?: string | undefined;
    remarks?: string | undefined;
    testResultFile?: AntiSkidCaseFileDto | undefined;

    constructor(data?: ILaboratoryTestResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.caseLaboratorySettingsId = _data["caseLaboratorySettingsId"];
            this.testDate = _data["testDate"];
            this.ggt = _data["ggt"];
            this.got = _data["got"];
            this.gpt = _data["gpt"];
            this.testResultTypeId = _data["testResultTypeId"];
            this.testResultType = _data["testResultType"] ? LookUpValueDto.fromJS(_data["testResultType"]) : <any>undefined;
            this.doctorId = _data["doctorId"];
            this.remarks = _data["remarks"];
            this.testResultFile = _data["testResultFile"] ? AntiSkidCaseFileDto.fromJS(_data["testResultFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LaboratoryTestResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LaboratoryTestResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["caseLaboratorySettingsId"] = this.caseLaboratorySettingsId;
        data["testDate"] = this.testDate;
        data["ggt"] = this.ggt;
        data["got"] = this.got;
        data["gpt"] = this.gpt;
        data["testResultTypeId"] = this.testResultTypeId;
        data["testResultType"] = this.testResultType ? this.testResultType.toJSON() : <any>undefined;
        data["doctorId"] = this.doctorId;
        data["remarks"] = this.remarks;
        data["testResultFile"] = this.testResultFile ? this.testResultFile.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILaboratoryTestResultDto {
    id?: string;
    caseLaboratorySettingsId?: number;
    testDate?: string | undefined;
    ggt?: number | undefined;
    got?: number | undefined;
    gpt?: number | undefined;
    testResultTypeId?: string | undefined;
    testResultType?: LookUpValueDto | undefined;
    doctorId?: string | undefined;
    remarks?: string | undefined;
    testResultFile?: AntiSkidCaseFileDto | undefined;
}

export class LookUpValueDto implements ILookUpValueDto {
    id?: string;
    type?: LookUpValueType;
    name?: string | undefined;
    value?: string | undefined;
    sortOrder?: number;
    isSystem?: boolean;
    isDeleted?: boolean;

    constructor(data?: ILookUpValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.sortOrder = _data["sortOrder"];
            this.isSystem = _data["isSystem"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): LookUpValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookUpValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        data["value"] = this.value;
        data["sortOrder"] = this.sortOrder;
        data["isSystem"] = this.isSystem;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ILookUpValueDto {
    id?: string;
    type?: LookUpValueType;
    name?: string | undefined;
    value?: string | undefined;
    sortOrder?: number;
    isSystem?: boolean;
    isDeleted?: boolean;
}

export enum LookUpValueType {
    Airline = "Airline",
    Insurance = "Insurance",
    Program = "Program",
    Function = "Function",
    Contact = "Contact",
    HistoryInput = "HistoryInput",
    Hospitalization = "Hospitalization",
    ProgramFailReason = "ProgramFailReason",
    FollowUpConsent = "FollowUpConsent",
    LaboratoryTestResult = "LaboratoryTestResult",
    LaboratoryDoctor = "LaboratoryDoctor",
    LaboratoryResultTestType = "LaboratoryResultTestType",
    GroupMeeting = "GroupMeeting",
    FileCategory = "FileCategory",
    LibraryFile = "LibraryFile",
}

export class SetCaseLaboratorySettingsCommand implements ISetCaseLaboratorySettingsCommand {
    caseId?: string;
    firstTestDate?: string | undefined;
    testTypes?: string[] | undefined;
    monthsInterval?: number | undefined;

    constructor(data?: ISetCaseLaboratorySettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseId = _data["caseId"];
            this.firstTestDate = _data["firstTestDate"];
            if (Array.isArray(_data["testTypes"])) {
                this.testTypes = [] as any;
                for (let item of _data["testTypes"])
                    this.testTypes!.push(item);
            }
            this.monthsInterval = _data["monthsInterval"];
        }
    }

    static fromJS(data: any): SetCaseLaboratorySettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetCaseLaboratorySettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseId"] = this.caseId;
        data["firstTestDate"] = this.firstTestDate;
        if (Array.isArray(this.testTypes)) {
            data["testTypes"] = [];
            for (let item of this.testTypes)
                data["testTypes"].push(item);
        }
        data["monthsInterval"] = this.monthsInterval;
        return data;
    }
}

export interface ISetCaseLaboratorySettingsCommand {
    caseId?: string;
    firstTestDate?: string | undefined;
    testTypes?: string[] | undefined;
    monthsInterval?: number | undefined;
}

export class ServiceResultOfLaboratoryTestResultContainer extends ServiceResult implements IServiceResultOfLaboratoryTestResultContainer {
    entity?: LaboratoryTestResultContainer | undefined;

    constructor(data?: IServiceResultOfLaboratoryTestResultContainer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"] ? LaboratoryTestResultContainer.fromJS(_data["entity"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServiceResultOfLaboratoryTestResultContainer {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfLaboratoryTestResultContainer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfLaboratoryTestResultContainer extends IServiceResult {
    entity?: LaboratoryTestResultContainer | undefined;
}

export class LaboratoryTestResultContainer implements ILaboratoryTestResultContainer {
    result?: LaboratoryTestResultDto | undefined;
    nextLabTestInfo?: NextLabTestInfoDto | undefined;

    constructor(data?: ILaboratoryTestResultContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? LaboratoryTestResultDto.fromJS(_data["result"]) : <any>undefined;
            this.nextLabTestInfo = _data["nextLabTestInfo"] ? NextLabTestInfoDto.fromJS(_data["nextLabTestInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LaboratoryTestResultContainer {
        data = typeof data === 'object' ? data : {};
        let result = new LaboratoryTestResultContainer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["nextLabTestInfo"] = this.nextLabTestInfo ? this.nextLabTestInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILaboratoryTestResultContainer {
    result?: LaboratoryTestResultDto | undefined;
    nextLabTestInfo?: NextLabTestInfoDto | undefined;
}

export class AntiSkidLibraryFileDto extends AntiSkidFileBaseDto implements IAntiSkidLibraryFileDto {

    constructor(data?: IAntiSkidLibraryFileDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AntiSkidLibraryFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new AntiSkidLibraryFileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAntiSkidLibraryFileDto extends IAntiSkidFileBaseDto {
}

export class ServiceResultOfListOfAntiSkidLibraryFileDto extends ServiceResult implements IServiceResultOfListOfAntiSkidLibraryFileDto {
    entity?: AntiSkidLibraryFileDto[] | undefined;

    constructor(data?: IServiceResultOfListOfAntiSkidLibraryFileDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["entity"])) {
                this.entity = [] as any;
                for (let item of _data["entity"])
                    this.entity!.push(AntiSkidLibraryFileDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ServiceResultOfListOfAntiSkidLibraryFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfListOfAntiSkidLibraryFileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entity)) {
            data["entity"] = [];
            for (let item of this.entity)
                data["entity"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfListOfAntiSkidLibraryFileDto extends IServiceResult {
    entity?: AntiSkidLibraryFileDto[] | undefined;
}

export class LookUpValueGroup implements ILookUpValueGroup {
    type?: LookUpValueType;
    lookUpValues?: LookUpValueDto[] | undefined;

    constructor(data?: ILookUpValueGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["lookUpValues"])) {
                this.lookUpValues = [] as any;
                for (let item of _data["lookUpValues"])
                    this.lookUpValues!.push(LookUpValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LookUpValueGroup {
        data = typeof data === 'object' ? data : {};
        let result = new LookUpValueGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.lookUpValues)) {
            data["lookUpValues"] = [];
            for (let item of this.lookUpValues)
                data["lookUpValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILookUpValueGroup {
    type?: LookUpValueType;
    lookUpValues?: LookUpValueDto[] | undefined;
}

export class GetLookUpValuesQuery implements IGetLookUpValuesQuery {
    filterTypes?: LookUpValueType[] | undefined;

    constructor(data?: IGetLookUpValuesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["filterTypes"])) {
                this.filterTypes = [] as any;
                for (let item of _data["filterTypes"])
                    this.filterTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLookUpValuesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetLookUpValuesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filterTypes)) {
            data["filterTypes"] = [];
            for (let item of this.filterTypes)
                data["filterTypes"].push(item);
        }
        return data;
    }
}

export interface IGetLookUpValuesQuery {
    filterTypes?: LookUpValueType[] | undefined;
}

export class ServiceResultOfLookUpValueDto extends ServiceResult implements IServiceResultOfLookUpValueDto {
    entity?: LookUpValueDto | undefined;

    constructor(data?: IServiceResultOfLookUpValueDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"] ? LookUpValueDto.fromJS(_data["entity"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServiceResultOfLookUpValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfLookUpValueDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfLookUpValueDto extends IServiceResult {
    entity?: LookUpValueDto | undefined;
}

export class CreateLookUpValueCommand implements ICreateLookUpValueCommand {
    type?: LookUpValueType;
    name?: string | undefined;
    value?: string | undefined;
    sortOrder?: number;

    constructor(data?: ICreateLookUpValueCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CreateLookUpValueCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLookUpValueCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["value"] = this.value;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICreateLookUpValueCommand {
    type?: LookUpValueType;
    name?: string | undefined;
    value?: string | undefined;
    sortOrder?: number;
}

export class UpdateLookUpValueCommand implements IUpdateLookUpValueCommand {
    value?: LookUpValueDto | undefined;

    constructor(data?: IUpdateLookUpValueCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? LookUpValueDto.fromJS(_data["value"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateLookUpValueCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLookUpValueCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateLookUpValueCommand {
    value?: LookUpValueDto | undefined;
}

export class UpdateLookUpValuesSortOrderCommand implements IUpdateLookUpValuesSortOrderCommand {
    orderedLookUpValues?: { [key: string]: number; } | undefined;

    constructor(data?: IUpdateLookUpValuesSortOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["orderedLookUpValues"]) {
                this.orderedLookUpValues = {} as any;
                for (let key in _data["orderedLookUpValues"]) {
                    if (_data["orderedLookUpValues"].hasOwnProperty(key))
                        (<any>this.orderedLookUpValues)![key] = _data["orderedLookUpValues"][key];
                }
            }
        }
    }

    static fromJS(data: any): UpdateLookUpValuesSortOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLookUpValuesSortOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.orderedLookUpValues) {
            data["orderedLookUpValues"] = {};
            for (let key in this.orderedLookUpValues) {
                if (this.orderedLookUpValues.hasOwnProperty(key))
                    (<any>data["orderedLookUpValues"])[key] = (<any>this.orderedLookUpValues)[key];
            }
        }
        return data;
    }
}

export interface IUpdateLookUpValuesSortOrderCommand {
    orderedLookUpValues?: { [key: string]: number; } | undefined;
}

export class CreateUserCommand implements ICreateUserCommand {
    email?: string | undefined;
    password?: string | undefined;
    roles?: ApplicationRoleType[] | undefined;
    isActive?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    city?: string | undefined;
    airline?: string | undefined;
    functionId?: string | undefined;
    nearestAirport?: string | undefined;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.isActive = _data["isActive"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.city = _data["city"];
            this.airline = _data["airline"];
            this.functionId = _data["functionId"];
            this.nearestAirport = _data["nearestAirport"];
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["isActive"] = this.isActive;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["city"] = this.city;
        data["airline"] = this.airline;
        data["functionId"] = this.functionId;
        data["nearestAirport"] = this.nearestAirport;
        return data;
    }
}

export interface ICreateUserCommand {
    email?: string | undefined;
    password?: string | undefined;
    roles?: ApplicationRoleType[] | undefined;
    isActive?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    city?: string | undefined;
    airline?: string | undefined;
    functionId?: string | undefined;
    nearestAirport?: string | undefined;
}

export class UpdateUserCommand extends CreateUserCommand implements IUpdateUserCommand {
    id?: number;

    constructor(data?: IUpdateUserCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateUserCommand extends ICreateUserCommand {
    id?: number;
}

export enum ApplicationRoleType {
    None = "None",
    SystemAdministrator = "SystemAdministrator",
    StatisticUser = "StatisticUser",
    CaseManager = "CaseManager",
    GroupAdmin = "GroupAdmin",
    Therapist = "Therapist",
    Peer = "Peer",
}

export class ServiceResultOfUserDto extends ServiceResult implements IServiceResultOfUserDto {
    entity?: UserDto | undefined;

    constructor(data?: IServiceResultOfUserDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"] ? UserDto.fromJS(_data["entity"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServiceResultOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfUserDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfUserDto extends IServiceResult {
    entity?: UserDto | undefined;
}

export class GetUsersQuery implements IGetUsersQuery {
    roles?: ApplicationRoleType[] | undefined;

    constructor(data?: IGetUsersQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUsersQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IGetUsersQuery {
    roles?: ApplicationRoleType[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}